import { useEffect, useState } from "react"

import { useQueryParam } from "web/hooks/context"
import { isNonEmptyArray, distinctBy, unique } from "web/services/helpers"

import { getMapBoxSafeValues } from "./common"

import LocationMap from "./LocationMap"
import DealLocationCard from "./LocationCard/DealLocationCard"

export default function DealMap({
  deals,
  onSelectionChanged,
  onItemClick,
  isLoading,
  showOrdinals,
}) {
  const [locationInFocus, setLocationInFocus] = useState()
  const hasLocationInFocus = !!locationInFocus

  const dealLocations = deals.reduce((locations, deal) => {
    const dealValues = getMapBoxSafeValues(deal.values)

    if (isNonEmptyArray(deal.locations)) {
      locations.push(
        ...deal.locations.map((al) => ({
          ...al,
          sticky: deal.sticky,
          deal_id: deal.id,
          values: dealValues,
        }))
      )
    }

    return locations
  }, [])

  const distinctDealLocations = distinctBy(dealLocations, "id")

  const locationInFocusWithSubjects = { location: locationInFocus }

  if (hasLocationInFocus) {
    const dealsAtLocation = deals.filter((d) =>
      d.locations?.some((l) => l.id === locationInFocus.id)
    )

    const dealAssetIdsAtLocation = dealsAtLocation
      .map((d) => d.locations)
      .flat()
      .filter((l) => l.id === locationInFocus.id)
      .map((l) => l.asset_id)

    const distinctDealAssetIdsAtLocation = unique(dealAssetIdsAtLocation)

    locationInFocusWithSubjects.deals = dealsAtLocation
    locationInFocusWithSubjects.assetIds = distinctDealAssetIdsAtLocation
  }

  const primarySubject =
    hasLocationInFocus && locationInFocusWithSubjects.deals[0]

  const hasPrimarySubject = !!primarySubject

  // deal in focus may have been removed between
  // renders by change in filter conditions
  useEffect(() => {
    if (hasLocationInFocus && !hasPrimarySubject) {
      setLocationInFocus(undefined)
    }
  }, [hasLocationInFocus, hasPrimarySubject])

  const selected = deals.filter((el) => el.selected)

  const center_on = useQueryParam("center_on")
  const centralLocation =
    // eslint-disable-next-line eqeqeq
    !!center_on && distinctDealLocations.find((l) => l.deal_id == center_on)

  return (
    <LocationMap
      subjectType="deal"
      subjects={deals}
      primarySubject={primarySubject}
      selected={selected}
      locations={distinctDealLocations}
      locationInFocus={locationInFocusWithSubjects}
      centralLocation={centralLocation}
      onLocationClick={setLocationInFocus}
      onItemClick={onItemClick}
      onSelectionChanged={onSelectionChanged}
      detailCard={DealLocationCard}
      isLoading={isLoading}
      canRecenterMap={true}
      showOrdinals={showOrdinals}
    />
  )
}
